import { AbstractCrudService } from 'app/services/abstract-crud/abstract-crud.service';
import { ApiHttpClient } from 'app/http/clients/api';
import { Injectable } from '@angular/core';
import { Team } from './../../models/dto/team.model';

@Injectable({
  providedIn: 'root'
})
export class TeamService extends AbstractCrudService<Team> {
  baseUrl = '/team/funnel';

  constructor(
    private httpConcrete: ApiHttpClient
  ) {
    super(httpConcrete);
  }

  // Basic CRUD done in parent class. Add outlier stuff here if needed.
}
